export default __webpack_public_path__ + "static/media/backgroung_tansparent.ed0a3287.png";